import { createContext } from 'react';

const DEFAULT_VALUES = {};

export const GitlabProjectsContext = createContext(DEFAULT_VALUES);
